import { createCrudActions } from "../utils/crudGenerator";

const formatSeasons = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.number}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchSeasons,
  create: createSeason,
  update: updateSeason,
  delete: deleteSeasons,
} = createCrudActions("SEASON", "Temporada", formatSeasons);
